import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { getRooms } from 'api/room/roomsApi'
import { IRequestResponse, IRoom, IRoomsMeta } from 'shared-ui'

export const fetchRooms = createAsyncThunk<IRequestResponse<IRoom>, IRoomsMeta>(
  'app/getRooms',
  async (meta, _) => {
    return getRooms(meta)
  }
)

export const selectRoom = createAction<IRoom>('room/selectRoom')
